"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchBar = void 0;
var React = __importStar(require("react"));
var react_1 = require("react");
var react_2 = require("@chakra-ui/react");
var Icon_1 = require("../../../Icon");
var pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
var useHeaderProps_1 = require("../../hooks/useHeaderProps");
var SearchBar = function (_a) {
    var searchInputRef = _a.searchInputRef, color = _a.color, inputGroupProps = __rest(_a, ["searchInputRef", "color"]);
    var _b = (0, react_1.useState)(''), searchTerm = _b[0], setSearchTerm = _b[1];
    var _c = (0, useHeaderProps_1.useHeaderProps)(), onRedirect = _c.onRedirect, defaultSearchDocType = _c.defaultSearchDocType, _js = _c._js;
    var onSubmitHandler = function (e) {
        e.preventDefault();
        var doctypeParam = '';
        if (defaultSearchDocType !== 'all') {
            doctypeParam = "&c-doctype_namespace=".concat(defaultSearchDocType);
        }
        onRedirect(encodeURI("/Search?query=".concat(searchTerm).concat(doctypeParam)));
    };
    return (React.createElement("form", { onSubmit: onSubmitHandler, className: "header-input__search", "data-feature-id": "header_input_search" },
        React.createElement(react_2.InputGroup, __assign({ size: "sm" }, inputGroupProps),
            React.createElement(react_2.InputLeftElement, { pointerEvents: "auto" },
                React.createElement(react_2.Button, { type: "submit", backgroundColor: "transparent", border: "none", _hover: { bg: 'none', color: 'gray.500' }, _focus: { bg: 'none' }, _active: { bg: 'none' }, padding: "0", "aria-label": "search" },
                    React.createElement(Icon_1.Icon, { type: pro_regular_svg_icons_1.faSearch, color: "gray.500" }))),
            React.createElement(react_2.Input, { type: "search", bg: "white", color: "gray.500", _placeholder: { color: 'gray.500' }, onChange: function (e) { return setSearchTerm(e.target.value); }, placeholder: _js('Search'), ref: searchInputRef }))));
};
exports.SearchBar = SearchBar;
